// components/Scoreboard.jsx
import React from 'react';
import {renderItemOrText} from "@utils/renderUtils.jsx";

function playerState(player, revealed, correct) {
    if (!revealed) return '';
    if (player.lastAnswer === correct) return 'correct';
    if (player.lastAnswer && player.lastAnswer !== correct) return 'wrong';
    return '';
}

export default function Scoreboard({ players, revealed, correct, layout = 'top' }) {
    return (
        <div className={`players-row ${layout}`}>
            {players.map((player, i) => (
                <div key={`${player.persistentId || 'unknown'}-${i}`} className={`player-card ${playerState(player, revealed, correct)}`}>
                    <div className="player-name">{player.name}</div>
                    <div className="player-score">{player.score}</div>
                    {revealed && player.lastAnswer && (
                        <div className="player-answer">
                            Antwort: {player.lastAnswer.split(/\s*\+\s*/).map((part, idx) => renderItemOrText(part.trim(), 20, idx))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}